import http from 'plugins/axios'

export default {
  getTigerList(params) {
    return http.get({
      url: `/la/admin/rebate/getRiskList`,
      params,
    })
  },
  getTigerListTotal(params) {
    return http.get({
      url: `/la/admin/tiger/listTotal`,
      params,
    })
  },
  getRebateListTotal(params) {
    return http.get({
      url: `/la/admin/rebate/rebateListTotal`,
      params,
    })
  },
  getExcelData(params) {
    return http.get({
      url: `/la/admin/rebate/getRiskListExcel`,
      params,
      responseType: 'blob',
    })
  },
}
